var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackStroke24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91028 5L0 12.5003L7.91028 20L9 18.8775L2.2749 12.5003L9 6.12209L7.91028 5Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackStroke24);
export default __webpack_public_path__ + "static/media/HeaderBack_Stroke_24.b227617150bc1a1c780aa3519df99610.svg";
export { ForwardRef as ReactComponent };